import React from 'react';
import './Carousel.css';

const Carousel = () => {

  const slides = [
    {
      id: 1,
      image: require('../images/carousel-1.jpg'),
      category: 'ARTICLE',
      title: 'AI-Powered Business Transformation',
      description: 'Revolutionize your operations with cutting-edge artificial intelligence solutions that drive efficiency, innovation, and competitive advantage in today\'s fast-paced market.'
    },
    {
      id: 2,
      image: require('../images/carousel-2.jpg'),
      category: 'INSIGHTS',
      title: 'Smart Analytics & Insights',
      description: 'Unlock the power of your data with advanced machine learning algorithms that transform raw information into actionable business intelligence.'
    },
    {
      id: 3,
      image: require('../images/carousel-3.jpg'),
      category: 'SOLUTIONS',
      title: 'Seamless Integration',
      description: 'Our AI solutions integrate seamlessly with your existing systems and workflows, ensuring minimal disruption and maximum value delivery.'
    }
  ];

  return (
    <section className="carousel-section">
      {slides.map((slide, index) => (
        <div key={slide.id} className="carousel-slide">
          <div className={`carousel-split-container ${index % 2 === 1 ? 'reverse' : ''}`}>
            <div className="carousel-text-side">
              <div className="carousel-content">
                <span className="carousel-category">
                  {slide.category}
                </span>
                <h2 className="carousel-title">
                  {slide.title}
                </h2>
                <p className="carousel-description">
                  {slide.description}
                </p>
              </div>
            </div>
            <div className="carousel-image-side">
              <img 
                src={slide.image} 
                alt={slide.title} 
                className="carousel-image" 
              />
            </div>
          </div>
        </div>
      ))}
    </section>
  );
};

export default Carousel;
